(function () {
  'use strict';

  if (window.LivvewellFreeGifts && window.LivvewellFreeGifts.__loaded) return;

  var API = window.LivvewellFreeGifts || {};
  API.__loaded = true;
  window.LivvewellFreeGifts = API;

  var config = window.LivvewellFreeGiftConfig || {};
  var eligibleProductIds = new Set((config.eligibleProductIds || []).map(String));
  var guideProductId = config.guide && config.guide.productId ? String(config.guide.productId) : '';
  var guideVariantId = config.guide && config.guide.variantId ? String(config.guide.variantId) : '';
  var clothVariantId = config.cloth && config.cloth.variantId ? String(config.cloth.variantId) : '52635096711482';
  var freeGiftProperty = config.properties && config.properties.freeGift ? config.properties.freeGift : '_lw_free_gift';
  var giftTypeProperty = config.properties && config.properties.giftType ? config.properties.giftType : '_lw_gift_type';
  var debug = config.debug === true;

  var syncing = false;
  var rerunRequested = false;
  var timer = null;

  function log() {
    if (!debug || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Livvewell Free Gifts]');
    console.log.apply(console, args);
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function endpoint(path) {
    return shopRoot() + String(path || '').replace(/^\/+/, '');
  }

  function getCart() {
    return window.fetch(endpoint('cart.js'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart.');
      return response.json();
    });
  }

  function updateCart(updates) {
    return window.fetch(endpoint('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update gift lines.');
      return response.json();
    });
  }

  function addGiftItems(items) {
    return window.fetch(endpoint('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not add free gifts.');
      return response.json();
    });
  }

  function stringId(value) {
    return value == null ? '' : String(value);
  }

  function hasQualifyingItem(cart) {
    return (cart.items || []).some(function (item) {
      return item && eligibleProductIds.has(stringId(item.product_id));
    });
  }

  function isAutoGiftLine(item, giftType) {
    if (!item) return false;
    var properties = item.properties || {};
    return String(properties[freeGiftProperty] || '') === 'true' &&
      String(properties[giftTypeProperty] || '') === giftType;
  }

  function isGuideItem(item) {
    if (!item) return false;
    return guideProductId
      ? stringId(item.product_id) === guideProductId
      : stringId(item.variant_id) === guideVariantId;
  }

  function isClothGiftItem(item) {
    return item && stringId(item.variant_id) === clothVariantId;
  }

  function giftItem(variantId, giftType) {
    var properties = {};
    properties[freeGiftProperty] = 'true';
    properties[giftTypeProperty] = giftType;

    return {
      id: Number(variantId),
      quantity: 1,
      properties: properties
    };
  }

  function planGift(cart, matcher, variantId, giftType, qualifying, updates, additions) {
    var matching = (cart.items || []).filter(matcher);
    var manualLines = matching.filter(function (item) {
      return !isAutoGiftLine(item, giftType);
    });
    var autoLines = matching.filter(function (item) {
      return isAutoGiftLine(item, giftType);
    });

    if (!qualifying) {
      autoLines.forEach(function (line) {
        if (line.key) updates[line.key] = 0;
      });
      return;
    }

    if (manualLines.length) {
      autoLines.forEach(function (line) {
        if (line.key) updates[line.key] = 0;
      });
      return;
    }

    if (!autoLines.length) {
      additions.push(giftItem(variantId, giftType));
      return;
    }

    autoLines.forEach(function (line, index) {
      if (!line.key) return;
      if (index === 0) {
        if (Number(line.quantity) !== 1) updates[line.key] = 1;
      } else {
        updates[line.key] = 0;
      }
    });
  }

  function buildPlan(cart) {
    var qualifying = hasQualifyingItem(cart);
    var updates = {};
    var additions = [];

    planGift(cart, isGuideItem, guideVariantId, 'calm-guide', qualifying, updates, additions);
    planGift(cart, isClothGiftItem, clothVariantId, 'lullacloth', qualifying, updates, additions);

    return {
      qualifying: qualifying,
      updates: updates,
      additions: additions
    };
  }

  function validateConfig() {
    if (!eligibleProductIds.size) {
      throw new Error('No eligible products loaded. Check collection handle free-gift-eligible-products.');
    }
    if (!guideVariantId) {
      throw new Error('Calm Baby Guide variant could not be resolved.');
    }
    if (!clothVariantId) {
      throw new Error('LullaCloth gift variant ID is missing.');
    }
  }

  async function reconcile() {
    if (syncing) {
      rerunRequested = true;
      return;
    }

    syncing = true;
    rerunRequested = false;
    var changed = false;

    try {
      validateConfig();
      var cart = await getCart();
      var plan = buildPlan(cart);
      log('Plan', plan);

      if (Object.keys(plan.updates).length) {
        changed = true;
        await updateCart(plan.updates);
      }

      if (plan.additions.length) {
        changed = true;
        await addGiftItems(plan.additions);
      }

      document.dispatchEvent(new CustomEvent('lw:free-gifts:reconciled', {
        detail: { qualifying: plan.qualifying, changed: changed }
      }));
    } catch (error) {
      console.warn('[Livvewell Free Gifts]', error);
      document.dispatchEvent(new CustomEvent('lw:free-gifts:error', {
        detail: { message: error && error.message ? error.message : String(error) }
      }));
    } finally {
      syncing = false;
      if (changed || rerunRequested) schedule(220);
    }
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, typeof delay === 'number' ? delay : 90);
  }

  window.addEventListener('lw:external-cart-mutation', function () {
    if (syncing) {
      rerunRequested = true;
      return;
    }
    schedule(80);
  });

  document.addEventListener('lw:cart:updated', function () {
    if (syncing) {
      rerunRequested = true;
      return;
    }
    schedule(80);
  });

  window.addEventListener('pageshow', function () {
    schedule(40);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') schedule(80);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(40);
    });
  } else {
    schedule(40);
  }

  API.sync = reconcile;
  API.getCart = getCart;
  API.buildPlan = buildPlan;
  API.config = config;
})();